<template>
    <div v-if="announcements.length" class="announcement-banner">
        <v-alert
            v-for="item in announcements"
            :key="item.id"
            :type="item.type"
            dense
            text
            dismissible
            class="mb-0"
            @input="dismiss(item)"
        >
            {{ item.message }}
        </v-alert>

        <div v-if="remaining" class="text-caption grey--text px-4 py-1">
            <span v-if="remaining === 1">1 more announcement. Close one above to see it.</span>
            <span v-else>{{ remaining }} more announcements. Close one above to see the next.</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnnouncementBanner',

    data: () => ({
        announcements: [],
        // How many live announcements the server held back. The cap lives on
        // the server, so the page is never sent banners it will not draw.
        remaining: 0
    }),

    created() {
        this.fetch()

        // A signal with no payload: the server decides what this viewer sees,
        // through the three-banner cap and their own dismissals. Reading the
        // announcement off the event instead would mean writing both of those
        // rules again here, where they would drift.
        Echo.channel('announcements').listen('.announcement.posted', () => {
            this.fetch()
        })
    },

    beforeDestroy() {
        // The banner lives as long as the app shell does, so this is belt and
        // braces. Without it a hot reload in development stacks a second
        // listener and every announcement fetches twice.
        Echo.leave('announcements')
    },

    methods: {
        fetch() {
            // skipGlobalError, and a catch that shows nothing: a notice that
            // failed to load must not put an error in front of a cashier at
            // the start of a shift. A banner that cannot appear should be
            // invisible, not loud.
            axios
                .get('/active-announcements', { skipGlobalError: true })
                .then((res) => {
                    this.announcements = res.data.data
                    this.remaining = res.data.remaining
                })
                .catch(() => {
                    this.announcements = []
                    this.remaining = 0
                })
        },

        dismiss(item) {
            // Refetched rather than only removed locally. Closing one banner
            // makes room for one that was held back, and the count has to come
            // down with it. This is the one case where the list really has
            // changed on the server.
            this.announcements = this.announcements.filter((a) => a.id !== item.id)

            axios
                .post('/dismiss-announcement', { id: item.id }, { skipGlobalError: true })
                .then(() => {
                    if (this.remaining > 0) this.fetch()
                })
                .catch(() => { })
        }
    }
}
</script>
